// src/serviceWorkerRegistration.js
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          // Force update check
          registration.update();
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    });

    // When a new service worker takes control (after any sw.js update),
    // dispatch an event so the app can immediately re-register the FCM token
    // and keep notifications uninterrupted.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.dispatchEvent(new CustomEvent('sw-controller-changed'));
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}